import { IntercomProvider } from "react-use-intercom";
import { AppConfig } from "shared/config/AppConfig";

export const AppIntercomProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <IntercomProvider appId={AppConfig.intercom.appId} autoBoot={false}>
    {children}
  </IntercomProvider>
);
